<!-- Cookie Preferences Dialog - Story 6.7 -->
<h2 mat-dialog-title id="cookie-preferences-title">
  {{ 'CONSENT.PREFERENCES.TITLE' | translate }}
</h2>

<mat-dialog-content>
  <p class="preferences-intro">
    {{ 'CONSENT.PREFERENCES.DESCRIPTION' | translate }}
  </p>

  <!-- AC6-7: Extensible cookie categories list -->
  @for (category of categories(); track category.id) {
    <div class="cookie-category" [class.required]="category.required">
      <div class="category-header">
        <h3 class="category-title">
          {{ category.titleKey | translate }}
        </h3>

        <!-- AC7: Toggle for non-required categories -->
        @if (!category.required) {
          <mat-slide-toggle
            [checked]="category.enabled"
            (change)="onCategoryToggleChange(category.id, $event.checked)"
            [attr.aria-label]="category.toggleAriaKey | translate"
            color="primary"
          >
            {{
              category.enabled
                ? ('CONSENT.PREFERENCES.ENABLED' | translate)
                : ('CONSENT.PREFERENCES.DISABLED' | translate)
            }}
          </mat-slide-toggle>
        }

        <!-- Required badge for strictly necessary cookies -->
        @if (category.required) {
          <span
            class="required-badge"
            [attr.aria-label]="'CONSENT.PREFERENCES.REQUIRED_ARIA' | translate"
          >
            {{ 'CONSENT.PREFERENCES.REQUIRED' | translate }}
          </span>
        }
      </div>

      <p class="category-description">
        {{ category.descriptionKey | translate }}
      </p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    class="secondary-button"
    (click)="close()"
    [attr.aria-label]="'CONSENT.PREFERENCES.CLOSE_ARIA' | translate"
  >
    {{ 'CONSENT.PREFERENCES.CLOSE' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!hasChanges()"
    [attr.aria-label]="'CONSENT.PREFERENCES.SAVE_ARIA' | translate"
  >
    {{ 'CONSENT.PREFERENCES.SAVE' | translate }}
  </button>
</mat-dialog-actions>
